import { render, staticRenderFns } from "./DealOrderAgain.vue?vue&type=template&id=2bd21c00"
import script from "./DealOrderAgain.vue?vue&type=script&lang=js"
export * from "./DealOrderAgain.vue?vue&type=script&lang=js"
import style0 from "./DealOrderAgain.vue?vue&type=style&index=0&id=2bd21c00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports